import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import FancyDropdownContext from 'dpl/components/FancyDropdown/context';

export default function FancyDropdownMenu({
  children,
  className,
  contentClassName,
  newDesignSystemStyles
}) {
  return (
    <FancyDropdownContext.Consumer>
      {({ isOpen, menuRef, positionAlignment, menuWidth }) => {
        if (!isOpen) {
          return null;
        }

        return (
          <div className="FancyDropdownMenu relative">
            <ul
              ref={menuRef}
              className={classnames(
                'w-100 z-max br1 overscroll-contain',
                {
                  absolute: positionAlignment !== 'static',
                  'right-0': positionAlignment === 'right',
                  'left-0': positionAlignment === 'left',
                  'fw-medium br12 bg-white overflow-hidden':
                    newDesignSystemStyles
                },
                className
              )}
              style={{
                width: menuWidth,
                boxShadow: newDesignSystemStyles
                  ? '0 5px 20px 4px rgba(0, 0, 0, 0.03)'
                  : null
              }}
            >
              <div className={classnames('bg-white', contentClassName)}>
                {children}
              </div>
            </ul>
          </div>
        );
      }}
    </FancyDropdownContext.Consumer>
  );
}

FancyDropdownMenu.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  newDesignSystemStyles: PropTypes.bool
};

FancyDropdownMenu.defaultProps = {
  className: null,
  contentClassName: 'ph2 pv2',
  newDesignSystemStyles: false
};
